/** Canonical PWA version from `apps/web/package.json`, injected at build/test time. */
export const APP_VERSION: string = __APP_VERSION__;

/**
 * Short Git SHA of the production artifact, or `dev` for local/test builds.
 * Injected at build time from HW_BUILD_ID — never read from a live Git checkout.
 */
export const APP_BUILD_ID: string = __APP_BUILD_ID__;

export const DEV_BUILD_ID = "dev";

const PRODUCTION_BUILD_ID = /^[0-9a-f]{7}$/;

export function isProductionBuildId(buildId: string): boolean {
  return PRODUCTION_BUILD_ID.test(buildId);
}

export function formatAppIdentity(
  version: string = APP_VERSION,
  buildId: string = APP_BUILD_ID,
): string {
  return `v${version} · ${buildId}`;
}
